import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  public refreshCart: BehaviorSubject<any> = new BehaviorSubject(null);
  public generalNotification: BehaviorSubject<any> = new BehaviorSubject(null);
  public nextStep: BehaviorSubject<any> = new BehaviorSubject(null);
  public previousStep: BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshAddress: BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshContactInfo: BehaviorSubject<any> = new BehaviorSubject(null);
  public continueSession: BehaviorSubject<any> = new BehaviorSubject(null);
  public addonBuySuccessfully: BehaviorSubject<any> = new BehaviorSubject(null);
  public mapService: BehaviorSubject<any> = new BehaviorSubject(null);
  public getAccountDetails:BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshAddressForNonLoggedIn: BehaviorSubject<any> = new BehaviorSubject(null);
  public preSelectDevlieryPreference: BehaviorSubject<any> = new BehaviorSubject(null);
  public updateAddress: BehaviorSubject<any> = new BehaviorSubject(null);
  public editAddressNotifyer: BehaviorSubject<any> = new BehaviorSubject(null);

  
  
  public refreshAlternativeContactInfo: BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshVisitorLineCartForPromoCode: BehaviorSubject<any> = new BehaviorSubject(null);
  public visitorLineLoadedSuccessfully: BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshVisitorLineCartForREmovePromoCode: BehaviorSubject<any> = new BehaviorSubject(null);
  public removePromoCodeOnCartOrderDelete: BehaviorSubject<any> = new BehaviorSubject(null);
  public refreshCartCheckout: BehaviorSubject<any> = new BehaviorSubject(null);
constructor() { }

}
